/**
 * Signup ends with "Connect your LinkedIn": a pop-up over AI Home (ConnectLinkedinModal).
 * The old full-page step at /connect-linkedin is kept, but nothing sends new accounts there.
 *
 * Whether an account still owes it is `linkedinStepDone` on the user record,
 * not browser storage: closing the tab has to resume the step on the next login,
 * from any browser or device. Existing accounts are backfilled as done.
 */
export const CONNECT_LINKEDIN_ROUTE = '/connect-linkedin';

/** Where an account that still owes the LinkedIn step is sent: AI Home, which shows the pop-up. */
export const LINKEDIN_STEP_ROUTE = '/ai-home';

/** Only an explicit false counts; a user object without the field is not pending. */
export const isLinkedinStepPending = user => (user?.data || user)?.linkedinStepDone === false;

/**
 * A hint, in this browser, that the account last loaded still owed the step.
 * The user record stays the source of truth; the hint only lets RouteGuard hold
 * a page back while that record loads, instead of showing it and then jumping
 * to step 3.
 */
const PENDING_HINT_KEY = 'linkedinStepPending';

export const rememberLinkedinStep = pending => {
  try {
    if (pending) localStorage.setItem(PENDING_HINT_KEY, '1');
    else localStorage.removeItem(PENDING_HINT_KEY);
  } catch {
    // storage unavailable: RouteGuard still redirects once the user loads
  }
};

export const linkedinStepHinted = () => {
  try {
    return localStorage.getItem(PENDING_HINT_KEY) === '1';
  } catch {
    return false;
  }
};
